export const COVID_19_VALUE = 'covid-19';
export const COVID_19_LABEL = 'COVID-19';
export const APPLY_CANCELLATION_FEE = 'applyCancellationFee';
export const SEND_EMAIL_TO_CUSTOMER_AND_BOOKER = 'sendEmail';
export const CANCELLATION_REASON = 'cancellationReason';
export const REASON_DETAILS = 'reasonDetails';
